// For full API documentation, including code examples, visit http://wix.to/94BuAAs

import wixWindow from 'wix-window';

$w.onReady(function () {
	//TODO: write your page related code here...
	let data = wixWindow.lightbox.getContext();
	if (data) {
		$w('#text3').text = "" + data.number;
		$w('#text2').text = data.title;
		$w('#text21').text = data.shortText;
		$w('#text1').html = data.text;
		$w('#image1').src = data.image;
	}
});